import { matchPath } from "react-router-dom";
import applicationMap from "services/applicationMap";

type RouteKey = Extract<
  keyof typeof applicationMap.routes,
  "jobsMyFilters" | "jobsAllPaid" | "jobsAllOpportunities" | "jobsClientAlerts"
>;

type RouteTesters = {
  [Key in RouteKey]: (currentPath: string) => boolean;
};

export const routeTesters: RouteTesters = {
  jobsMyFilters: (currentPath) =>
    Boolean(
      matchPath(currentPath, {
        path: applicationMap.routes.jobsMyFilters(),
        strict: true,
      })
    ),
  jobsAllPaid: (currentPath) =>
    Boolean(
      matchPath(currentPath, {
        path: applicationMap.routes.jobsAllPaid(),
        strict: true,
      })
    ),
  jobsAllOpportunities: (currentPath) =>
    Boolean(
      matchPath(currentPath, {
        path: applicationMap.routes.jobsAllOpportunities(),
        strict: true,
      })
    ),
  jobsClientAlerts: (currentPath) =>
    Boolean(
      matchPath(currentPath, {
        path: applicationMap.routes.jobsClientAlerts(),
        strict: true,
      })
    ),
};
